<template>
	<button
		type="button"
		class="option-card"
		:class="{ 'option-card--selected': selected, 'option-card--compact': compact, 'option-card--light': light }"
		:aria-pressed="selected ? 'true' : 'false'"
		@click="$emit('select')"
	>
		<svg
			v-if="icon"
			class="option-card__icon"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			stroke-width="1.6"
			stroke-linecap="round"
			stroke-linejoin="round"
			aria-hidden="true"
		>
			<path v-for="d in icon" :key="d" :d="d" />
		</svg>
		<span class="option-card__title">{{ title }}</span>
		<span v-if="subtitle" class="option-card__subtitle">{{ subtitle }}</span>
	</button>
</template>

<script>
export default {
	name: 'OptionCard',

	props: {
		title: { type: String, required: true },
		subtitle: { type: String, default: '' },
		// Массив d-атрибутов для <path> (простые линейные иконки 24x24)
		icon: { type: Array, default: null },
		selected: { type: Boolean, default: false },
		compact: { type: Boolean, default: false },
		// Вариант для светлого фона (попап)
		light: { type: Boolean, default: false },
	},

	emits: ['select'],
};
</script>

<style lang="scss" scoped>
.option-card {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 6px;
	width: 100%;
	min-height: 64px;
	padding: 18px 16px;
	box-sizing: border-box;
	text-align: left;
	font: inherit;
	color: #ffffff;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.15);
	border-radius: 12px;
	cursor: pointer;
	transition: border-color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;

	&:hover {
		border-color: rgba(255, 255, 255, 0.35);
		background-color: rgba(255, 255, 255, 0.08);
	}

	&:focus-visible {
		outline: 2px solid rgba(248, 171, 0, 0.7);
		outline-offset: 2px;
	}

	&--selected,
	&--selected:hover {
		border-color: rgb(248, 171, 0);
		background-color: rgba(248, 171, 0, 0.12);
		box-shadow: 0 0 0 1px rgb(248, 171, 0), 0 0 18px rgba(248, 171, 0, 0.15);
	}

	&--compact {
		min-height: 0;
		padding: 12px 14px;
		align-items: center;
		text-align: center;
	}

	&__icon {
		width: 28px;
		height: 28px;
		margin-bottom: 4px;
		color: rgba(255, 255, 255, 0.7);
		transition: color 0.2s ease;
	}

	&--selected &__icon { color: rgb(248, 171, 0); }

	&__title {
		font-size: 15px;
		font-weight: 500;
		line-height: 1.25;
	}

	&--compact &__title { font-size: 14px; }

	&__subtitle {
		font-size: 12px;
		line-height: 1.4;
		color: rgba(255, 255, 255, 0.5);
	}

	// ─── Светлая тема ───────────────────────────────────
	// Цвета можно переопределить CSS-переменными на родителе (например, на лендинге):
	// --option-card-light-bg, --option-card-light-border, --option-card-light-icon
	&--light {
		color: rgba(25, 25, 25, 1);
		background-color: var(--option-card-light-bg, rgba(25, 25, 25, 0.03));
		border-color: var(--option-card-light-border, rgba(25, 25, 25, 0.15));

		&:hover {
			border-color: rgba(25, 25, 25, 0.35);
			background-color: var(--option-card-light-bg-hover, rgba(25, 25, 25, 0.05));
		}
	}

	&--light &__icon     { color: var(--option-card-light-icon, rgba(25, 25, 25, 0.6)); }
	&--light &__subtitle { color: rgba(25, 25, 25, 0.5); }

	&--light.option-card--selected,
	&--light.option-card--selected:hover {
		border-color: rgb(248, 171, 0);
		background-color: rgba(248, 171, 0, 0.08);
		box-shadow: 0 0 0 1px rgb(248, 171, 0);
	}

	&--light.option-card--selected &__icon { color: #d89e1c; }
}
</style>
